import { render, staticRenderFns } from "./AtenaLabelSuggest.vue?vue&type=template&id=94f8c6fc"
import script from "./AtenaLabelSuggest.vue?vue&type=script&setup=true&lang=ts"
export * from "./AtenaLabelSuggest.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports